export default __webpack_public_path__ + "static/media/design-color.2afe9423.png";